import { render, staticRenderFns } from "./TeaserSlider.vue?vue&type=template&id=2d52161c"
import script from "./TeaserSlider.vue?vue&type=script&lang=js"
export * from "./TeaserSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports